/* Lead time checkbox global initializer (scoped rewrite).
 *
 * Usage:
 * - Include this file once in your theme JS bundle.
 * - Render `lead-time-checkbox-global.liquid` where product forms exist.
 *
 * Behavior:
 * - Initializes per root (document or Product Drawer).
 * - No global observers or continuous DOM scanning.
 * - Always refetches lead time on quick view open.
 * - Blocks/unblocks buttons deterministically and respects oot-disabled.
 */
(function () {
  if (window.LeadTimeCheckboxGlobalInit) {
    return;
  }

  var rootStates = new WeakMap();

  function escapeValue(val) {
    if (!val) return '';
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(val);
    }
    return String(val).replace(/"/g, '\\"');
  }

  function queryAll(scope, selector) {
    if (scope && scope.querySelectorAll) {
      return scope.querySelectorAll(selector);
    }
    return document.querySelectorAll(selector);
  }

  function getById(scope, id) {
    if (!id) return null;
    if (scope && scope.querySelector) {
      return scope.querySelector('#' + escapeValue(id));
    }
    return document.getElementById(id);
  }

  function collectButtons(scope, container, formId) {
    var set = new Set();
    var buttonSelectors = ['button[type="submit"]', 'input[type="submit"]'];

    if (formId) {
      var targetForm = getById(scope, formId) || document.getElementById(formId);
      if (targetForm) {
        buttonSelectors.forEach(function (selector) {
          targetForm.querySelectorAll(selector).forEach(function (btn) {
            set.add(btn);
          });
        });
      }
      var formSelector = buttonSelectors
        .map(function (s) {
          return s + '[form="' + escapeValue(formId) + '"]';
        })
        .join(',');
      queryAll(scope, formSelector).forEach(function (btn) {
        set.add(btn);
      });
      document.querySelectorAll(formSelector).forEach(function (btn) {
        set.add(btn);
      });
    }

    var rootButtons =
      (container && container.closest
        ? container.closest('section, form, .product-add-to-cart-container, .buy-buttons')
        : null) || (container ? container.parentElement : null);
    if (rootButtons) {
      buttonSelectors.forEach(function (selector) {
        rootButtons.querySelectorAll(selector).forEach(function (btn) {
          set.add(btn);
        });
      });
    }

    queryAll(scope, 'buy-buttons [type="submit"]').forEach(function (btn) {
      set.add(btn);
    });
    queryAll(scope, '.product-add-to-cart-container [type="submit"]').forEach(function (btn) {
      set.add(btn);
    });

    return Array.from(set).filter(function (btn) {
      return btn.closest('form') || btn.hasAttribute('form');
    });
  }

  function updateButton(btn, disabled, forceEnable) {
    if (!btn || (btn.classList && btn.classList.contains('oot-disabled'))) {
      return;
    }

    if (disabled) {
      if (!btn.hasAttribute('disabled')) {
        btn.setAttribute('disabled', 'disabled');
      }
      btn.setAttribute('data-lead-time-disabled', '1');
      if (!btn.classList.contains('lead-time-disabled')) {
        btn.classList.add('lead-time-disabled');
      }
      btn.setAttribute('data-lead-time-class', '1');
    } else {
      if (forceEnable) {
        if (btn.hasAttribute('disabled')) {
          btn.removeAttribute('disabled');
        }
        btn.removeAttribute('data-lead-time-disabled');
        btn.classList.remove('lead-time-disabled');
        btn.removeAttribute('data-lead-time-class');
      } else {
        if (btn.getAttribute('data-lead-time-disabled') === '1') {
          btn.removeAttribute('disabled');
          btn.removeAttribute('data-lead-time-disabled');
        }
        if (btn.getAttribute('data-lead-time-class') === '1') {
          btn.classList.remove('lead-time-disabled');
          btn.removeAttribute('data-lead-time-class');
        }
      }
    }
  }

  function isVariantChange(target) {
    if (!target || !target.matches) {
      return false;
    }
    if (
      target.matches('input[name="id"], select[name="id"]') ||
      target.matches('input[type="radio"][name], input[type="radio"][form]')
    ) {
      return true;
    }
    return !!target.closest('variant-selects, product-form, form[action*="/cart/add"]');
  }

  function createEntry(container, scope) {
    var productId = container.getAttribute('data-product-id');
    if (!productId || !/^\d+$/.test(productId)) {
      return null;
    }

    var entry = {
      container: container,
      scope: scope,
      formId: container.getAttribute('data-form-id') || '',
      checkbox: container.querySelector('[data-lead-time-checkbox]'),
      daysNode: container.querySelector('[data-lead-time-days]'),
      buttons: [],
      state: {
        pending: true,
        agreementRequired: false,
        agreementChecked: false,
        leadTimeDays: 0,
        resolved: false
      }
    };

    entry.state.agreementChecked = entry.checkbox ? entry.checkbox.checked : false;

    entry.shouldDisable = function () {
      return entry.state.pending || (entry.state.agreementRequired && !entry.state.agreementChecked);
    };

    entry.renderContainer = function () {
      if (!entry.state.resolved || !entry.state.agreementRequired || entry.state.leadTimeDays <= 0) {
        entry.container.style.display = 'none';
        return;
      }
      if (entry.daysNode) {
        entry.daysNode.textContent = entry.state.leadTimeDays;
      }
      entry.container.style.display = 'block';
    };

    entry.applyState = function () {
      var disabled = entry.shouldDisable();
      entry.buttons.forEach(function (btn) {
        updateButton(btn, disabled, !disabled && entry.state.resolved);
      });
    };

    entry.refreshDom = function () {
      var nextFormId = entry.container.getAttribute('data-form-id') || '';
      if (nextFormId && nextFormId !== entry.formId) {
        entry.formId = nextFormId;
      }
      entry.checkbox = entry.container.querySelector('[data-lead-time-checkbox]');
      entry.daysNode = entry.container.querySelector('[data-lead-time-days]');
      if (entry.checkbox) {
        entry.state.agreementChecked = entry.checkbox.checked;
      }
      entry.buttons = collectButtons(entry.scope, entry.container, entry.formId);
      entry.renderContainer();
      entry.applyState();
    };

    entry.onCheckboxChange = function (event) {
      var target = event && event.target ? event.target : null;
      if (!target || !target.matches || !target.matches('[data-lead-time-checkbox]')) {
        return;
      }
      if (!entry.container.contains(target)) {
        return;
      }
      entry.state.agreementChecked = target.checked;
      entry.applyState();
    };

    entry.fetchLeadTime = function () {
      fetch('/apps/api/products-lead-time', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ productIds: [productId] })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Lead time endpoint error: ' + response.status);
          }
          return response.json();
        })
        .then(function (data) {
          var leadTime = data && data.leadTime ? data.leadTime : data;
          entry.state.pending = false;
          entry.state.resolved = true;

          if (
            !leadTime ||
            typeof leadTime.leadTimeDays !== 'number' ||
            leadTime.leadTimeDays <= 0
          ) {
            entry.state.agreementRequired = false;
            entry.state.leadTimeDays = 0;
            entry.renderContainer();
            entry.applyState();
            return;
          }

          if (!leadTime.enforceUserAgreement) {
            entry.state.agreementRequired = false;
            entry.state.leadTimeDays = leadTime.leadTimeDays;
            entry.renderContainer();
            entry.applyState();
            return;
          }

          entry.state.agreementRequired = true;
          entry.state.leadTimeDays = leadTime.leadTimeDays;
          entry.state.agreementChecked = entry.checkbox ? entry.checkbox.checked : false;
          entry.renderContainer();
          entry.applyState();
        })
        .catch(function (error) {
          entry.state.pending = false;
          entry.state.resolved = true;
          entry.state.agreementRequired = false;
          entry.state.leadTimeDays = 0;
          entry.renderContainer();
          entry.applyState();
          console.error('lead time checkbox global error:', error);
        });
    };

    entry.init = function () {
      entry.container.addEventListener('change', entry.onCheckboxChange, true);
      entry.refreshDom();
      entry.fetchLeadTime();
    };

    entry.destroy = function () {
      entry.container.removeEventListener('change', entry.onCheckboxChange, true);
    };

    return entry;
  }

  function initRoot(root, options) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    var existing = rootStates.get(root);
    if (existing) {
      if (options && options.force) {
        existing.destroy();
        rootStates.delete(root);
      } else {
        if (options && options.refresh) {
          existing.refreshAll();
        }
        return;
      }
    }

    var state = {
      root: root,
      entries: new Map()
    };

    state.refreshAll = function () {
      state.entries.forEach(function (entry) {
        entry.refreshDom();
      });
    };

    state.onRootChange = function (event) {
      if (isVariantChange(event.target)) {
        state.refreshAll();
      }
    };

    state.destroy = function () {
      state.root.removeEventListener('change', state.onRootChange, true);
      state.entries.forEach(function (entry) {
        entry.destroy();
      });
      state.entries.clear();
    };

    root.querySelectorAll('[data-lead-time-scope]').forEach(function (container) {
      var entry = createEntry(container, root);
      if (!entry) {
        return;
      }
      state.entries.set(container, entry);
      entry.init();
    });

    root.addEventListener('change', state.onRootChange, true);
    rootStates.set(root, state);
  }

  function getDrawerContent() {
    return document.getElementById('Product-Drawer-Content');
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRoot(document, null);
  });

  document.addEventListener('quick-view:open', function () {
    var drawerContent = getDrawerContent();
    if (!drawerContent) {
      return;
    }
    initRoot(drawerContent, { force: true });
  });

  window.LeadTimeCheckboxGlobalInit = {
    initRoot: initRoot
  };
})();